import { useEffect, useState } from 'react'
import { supabase } from '../lib/supabase'

import type { UserRole } from '../types'

interface AdminGuardState {
  role: UserRole | null
  isSuperAdmin: boolean
  isAdmin: boolean
  loading: boolean
}

export function useAdminGuard(): AdminGuardState {
  const [role, setRole] = useState<UserRole | null>(null)
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    supabase.auth.getUser().then(({ data: { user } }) => {
      if (!user) { setLoading(false); return }
      supabase
        .from('profiles')
        .select('role')
        .eq('id', user.id)
        .single()
        .then(({ data }) => {
          setRole((data?.role as UserRole) ?? null)
          setLoading(false)
        })
    })
  }, [])

  return {
    role,
    isSuperAdmin: role === 'superadmin',
    isAdmin: role === 'admin' || role === 'superadmin',
    loading,
  }
}
